import event1 from './../images/events-1.png'
import event2 from './../images/events-2.png'
import event3 from './../images/events-3.png'
import logoAlchemy from './../images/logos/alchemy-logo.svg'
import logoAlisonAi from './../images/logos/alison-ai-logo.svg'
import logoBCapitalGroup from './../images/logos/b-capital-group-logo.svg'
import logoLayerZero from './../images/logos/layer-zero-logo.svg'
import logoNavier from './../images/logos/navier-logo.svg'
import logoNex from './../images/logos/nex-logo.svg'
import polygonNex from './../images/logos/polygon-logo.svg'

export interface IEvent {
  title: string
  description: string
  image: any
  youtubeVideoId: string
}

export const eventsData: IEvent[] = [
  {
    title: 'The MarketX Hotseat',
    description: 'Reimagine Credit w/ Sanjay Uppal, finbots.ai Founder & CEO',
    image: event1,
    youtubeVideoId: 'EfW1IAa41Ik',
  },
  {
    title: 'Biggest VC Risks & Challenges for 2023',
    description: 'AIM Summit London 2023',
    image: event2,
    youtubeVideoId: 'U_tV6LhchrA',
  },
  {
    title: 'MarketX Speaker Series',
    description: 'Sarah Chen, Co-founder and CEO of Beyond the Billion',
    image: event3,
    youtubeVideoId: 'sFGWFM2ppfs',
  },
]

export interface ICompany {
  name: string
  image: string
}

export const companiesData: ICompany[] = [
  {
    name: 'Alchemy',
    image: logoAlchemy,
  },
  {
    name: 'Alison.Ai',
    image: logoAlisonAi,
  },
  {
    name: 'B Capital Group',
    image: logoBCapitalGroup,
  },
  {
    name: 'Layer Zero',
    image: logoLayerZero,
  },
  {
    name: 'Navier',
    image: logoNavier,
  },
  {
    name: 'Nex',
    image: logoNex,
  },
]
